<template>
  <div>
    <v-btn x-small rounded :color="getThemeColor" dark @click="openDialog()" v-if="isManager">
      <v-icon>mdi-plus</v-icon>
    </v-btn>

    <v-dialog v-model="dialog" width="600" persistent>
      <v-card>
        <v-card-title
          :style="{'background-color':getThemeColor,'color':'white'}"
          class="headline lighten-2"
        >Create Expense Category</v-card-title>
        <v-text-field class="mx-10" v-model="categoryName" label="Category"></v-text-field>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn rounded color="primary" dark @click="closeDialog()">Cancel</v-btn>
          <v-btn rounded color="error" dark @click="createExpenseCategoryNow()">Create Now</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import axios from "@/plugins/axios";

export default {
  computed: {
    getAccessToken() {
      return this.$store.getters.getAccessToken;
    },
    getThemeColor() {
      return this.$store.getters.getThemeColor;
    },
    isManager() {
      return this.$store.getters.isManager;
    }
  },
  data() {
    return {
      dialog: false,
      categoryName: null
    };
  },
  methods: {
    openDialog() {
      this.dialog = true;
    },
    closeDialog() {
      this.dialog = false;
    },
    createExpenseCategoryNow() {
      if (this.categoryName == null) {
        alert("Category Name is Required !!");
        return false;
      } else {
        this.$store.commit("setLoader", true);
        axios
          .postDataWithToken(
            "/auth/create-expense-category",
            { categoryName: this.categoryName },
            this.getAccessToken
          )
          .then(categories => {
            this.$store.commit("setExpensesCategories", categories);
            this.$store.commit("setLoader", false);
            this.closeDialog();
          });
      }
    }
  }
};
</script>

<style>
</style>